import {
  createActions,
  createReqConsts,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('programs', 'accountVaultsForm');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'users',
  type: 'post',
  slug: [
    {
      type: 'payload',
      selector: ['userId'],
    },
    'accountvaults',
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/programs/accountVaultsForm.js